import { Flex, TableContainer, Table, Thead, Tr, Th, Td, Tbody, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import InputField from 'components/ui/InputField';

const BillTerm = ({ textColor, billTermData, billTerms, netAmount, handleBillTermChange, errors, refs }) => {
   const handleAmountChange = (index, value, term) => {
      const processedValue = parseFloat(value) || 0;
      const currentBasicAmount = parseFloat(netAmount) || 0;
      const calculatedPercentage =
         currentBasicAmount !== 0 ? ((Math.abs(processedValue) / currentBasicAmount) * 100).toFixed(2) : 0;
      const finalAmount =
         term?.signname === 'Subtraction'
            ? -Math.abs(processedValue)
            : term?.signname === 'Addition'
            ? Math.abs(processedValue)
            : processedValue;

      handleBillTermChange(index, {
         amount: finalAmount,
         percentage: calculatedPercentage,
         billTermId: term.id,
      });
   };

   const handlePercentageChange = (index, value, term) => {
      const percentage = parseFloat(value) || 0;
      const currentBasicAmount = parseFloat(netAmount) || 0;

      let calculatedAmount = (currentBasicAmount * percentage) / 100;

      const finalAmount =
         term?.signname === 'Subtraction'
            ? -Math.abs(calculatedAmount)
            : term?.signname === 'Addition'
            ? Math.abs(calculatedAmount)
            : calculatedAmount;

      handleBillTermChange(index, {
         amount: finalAmount.toFixed(2),
         percentage: percentage,
         billTermId: term.id,
      });
   };
   const headerbg = useColorModeValue("gray.200", "#262b33");

   return (
      <Flex justifyContent="flex-end" alignItems="flex-start">
         <TableContainer
            maxH="300px"
            border="1px"
            borderColor="gray.200"
            borderRadius={5}
            maxWidth="xl"
            overflowY="auto">
            <Table variant="simple" size="sm" maxWidth="xl">
               <Thead bg={headerbg}>
                  <Tr>
                     <Th color={textColor} minW="200px">
                        Description
                     </Th>
                     <Th color={textColor} minW="150px">
                        Perc(%)
                     </Th>

                     <Th color={textColor} minW="120px">
                        Amount
                     </Th>
                  </Tr>
               </Thead>
               <Tbody>
                  {billTermData?.map((term, index) => {
                     const saleBillTerm = billTerms?.find((item) => {
                        return item.billTermId === term.id;
                     });

                     return (
                        <Tr key={index}>
                           <Td>
                              {term?.signname === 'Both'
                                 ? '(±)'
                                 : term?.signname === 'Addition'
                                 ? '(+)'
                                 : term?.signname === 'Subtraction'
                                 ? '(-)'
                                 : ''}
                              {term.description || term?.signname}
                           </Td>
                           <Td maxWidth={20} border="1px solid" borderColor="gray.200" p={2}>
                              <InputField
                                 ref={(el) => {
                                    if (refs?.percentageRefs && refs?.percentageRefs.current) {
                                       refs.percentageRefs.current[index] = el;
                                    }
                                 }}
                                 type="number"
                                 name={`percentage`}
                                 label="Percentage"
                                 value={saleBillTerm && saleBillTerm.percentage ? saleBillTerm.percentage : ''}
                                 onChange={(e) => handlePercentageChange(index, e.target.value, term)}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                       e.preventDefault();
                                       if (refs?.amountRefs?.current[index]) {
                                          refs.amountRefs.current[index].focus();
                                       }
                                    }
                                    if (e.key === 'Tab') {
                                       e.preventDefault();
                                       if (e.shiftKey) {
                                          if (refs?.amountRefs?.current[index - 1]) {
                                             refs.amountRefs?.current[index - 1].focus();
                                          } else {
                                             if (refs?.rateRefs?.current) {
                                                const lastIndex = refs.rateRefs.current.length - 1;
                                                refs.rateRefs.current[lastIndex]?.focus();
                                             }
                                          }
                                       } else {
                                          if (refs?.amountRefs?.current[index]) {
                                             refs.amountRefs.current[index].focus();
                                          }
                                       }
                                    }
                                 }}
                              />
                           </Td>
                           <Td maxWidth={40} border="1px solid" borderColor="gray.200" p={2}>
                              <InputField
                                 ref={(el) => {
                                    if (refs?.amountRefs && refs?.amountRefs.current) {
                                       refs.amountRefs.current[index] = el;
                                    }
                                 }}
                                 type="number"
                                 name={`amount`}
                                 label="Amount"
                                 value={billTerms[index]?.amount || ''}
                                 onChange={(e) => handleAmountChange(index, e.target.value, term)}
                                 onKeyDown={(e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                       e.preventDefault();
                                    }

                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                       e.preventDefault();
                                       if (refs?.percentageRefs?.current[index + 1]) {
                                          refs.percentageRefs?.current[index + 1].focus();
                                       } else {
                                          if (refs?.dueDaysRef?.current) {
                                             refs.dueDaysRef?.current.focus();
                                          }
                                       }
                                    }
                                    if (e.key === 'Tab') {
                                       e.preventDefault();
                                       if (e.shiftKey) {
                                          if (refs?.percentageRefs?.current[index]) {
                                             refs.percentageRefs?.current[index].focus();
                                          }
                                       } else {
                                          if (refs?.percentageRefs?.current[index + 1]) {
                                             refs.percentageRefs?.current[index + 1].focus();
                                          } else {
                                             if (refs?.dueDaysRef?.current) {
                                                refs.dueDaysRef?.current.focus();
                                             }
                                          }
                                       }
                                    }
                                 }}
                                 onWheel={(e) => e.target.blur()}
                              />
                           </Td>
                        </Tr>
                     );
                  })}
               </Tbody>
            </Table>
         </TableContainer>
      </Flex>
   );
};

export default BillTerm;
